import { setupLayouts } from 'virtual:generated-layouts';
import { createRouter, createWebHistory } from 'vue-router';
import { useAuthStore } from '~/stores/useAuthStore';
import routes from '~pages';

const router = createRouter({
  history: createWebHistory(),
  routes: setupLayouts(routes),
});

router.beforeEach((to, from, next) => {
  const { authenticated } = useAuthStore();

  const { isAuthRequired } = to.meta;

  if (isAuthRequired && !authenticated)
    return next({ name: 'index' });
  else
    next();
});

export default router;
